import { Box, BoxProps } from 'theme-ui';

export type OverlayProps = BoxProps;

const Overlay: React.FC<OverlayProps> = (props) => (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'primary',
      opacity: 'semiOpaque',
      zIndex: -1
    }}
    {...props}
  />
);

export default Overlay;
